// extracted by mini-css-extract-plugin
export default {"root":"ExpirationDate_root__phBYH","autoRenewal":"ExpirationDate_autoRenewal__p271J"};